// Shared session-expiry handling. Used by the global fetch/axios interceptors
// in utils/apiInterceptor.js.

export function clearAuthSession() {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('userRole');
}

// Full-page redirect (not React Router navigate) is intentional here: session
// expiry is a security boundary, so we want a hard reset of all in-memory
// component state, not just a route change.
export function redirectToExpiredLogin() {
  clearAuthSession();
  if (!window.location.pathname.endsWith('/login')) {
    window.location.href = '/login?expired=1';
  }
}
